import BaseService from '@src/services/BaseService'

class PosVisitedService extends BaseService {
    constructor() {
        super('dashboards/pos-visited')
    }
}

export default new PosVisitedService()
